export const QUEST_BASE_CHANCE = 50;
export const QUEST_ON_LEVEL_BONUS = 10;
export const QUEST_CHANCE_CAP = 98;
export const QUEST_LEVEL_STEP = 5;

export const UNIT_SLUGS = ["defender", "scout", "melee", "ranged", "support"];
export const TROOP_WEIGHTS = {
  defender: 0.5,
  melee: 0.6,
  ranged: 0.6,
  scout: 0.4,
  support: 0.5,
};
export const TROOP_BOOST_CAP = 20;

export function questAllowsTroops(quest) {
  return quest?.allows_troops !== false;
}

export function normalizeAssignedTroops(value) {
  const out = {};
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return out;
  }
  for (const slug of UNIT_SLUGS) {
    const n = Math.max(0, Math.floor(Number(value[slug]) || 0));
    if (n > 0) out[slug] = n;
  }
  return out;
}

export function assignedTroopCount(assignedTroops) {
  const troops = normalizeAssignedTroops(assignedTroops);
  return UNIT_SLUGS.reduce((sum, slug) => sum + (troops[slug] || 0), 0);
}

export function troopBoostFromAssignment(assignedTroops) {
  const troops = normalizeAssignedTroops(assignedTroops);
  let weighted = 0;
  for (const slug of UNIT_SLUGS) {
    weighted += (troops[slug] || 0) * (TROOP_WEIGHTS[slug] || 0);
  }
  return Math.min(TROOP_BOOST_CAP, Math.floor(weighted));
}

export function questChanceBeforeGold({
  heroLevel,
  questLevel,
  troopBoost = 0,
}) {
  const troop = Number(troopBoost) || 0;
  if (heroLevel == null) {
    return QUEST_BASE_CHANCE + troop;
  }
  return (
    QUEST_BASE_CHANCE +
    QUEST_ON_LEVEL_BONUS +
    (heroLevel - questLevel) * QUEST_LEVEL_STEP +
    troop
  );
}

export function calculateQuestSuccessChance({
  heroLevel,
  questLevel,
  addedGold = 0,
  goldCostPerPercent = 0,
  troopBoost = 0,
}) {
  const goldBoost = goldCostPerPercent > 0 ? addedGold / goldCostPerPercent : 0;
  const raw =
    questChanceBeforeGold({ heroLevel, questLevel, troopBoost }) + goldBoost;
  return Math.min(Math.floor(raw), QUEST_CHANCE_CAP);
}

export function maxGoldForChanceCap({
  heroLevel,
  questLevel,
  goldCostPerPercent = 0,
  troopBoost = 0,
}) {
  if (goldCostPerPercent <= 0) return 0;
  const remaining = Math.max(
    0,
    QUEST_CHANCE_CAP -
      questChanceBeforeGold({ heroLevel, questLevel, troopBoost })
  );
  return remaining * goldCostPerPercent;
}
